'use strict';

$('#expert-notification a').on('click', function (event) {
  event.preventDefault();
  event.stopPropagation();
  $('#testinfo').modal({
    show: true
  });
});
